import { render, staticRenderFns } from "./CustomSideBar.vue?vue&type=template&id=28873c84&scoped=true"
import script from "./CustomSideBar.vue?vue&type=script&lang=js"
export * from "./CustomSideBar.vue?vue&type=script&lang=js"
import style0 from "./CustomSideBar.vue?vue&type=style&index=0&id=28873c84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28873c84",
  null
  
)

export default component.exports